module.exports = __webpack_public_path__ + "static/dd8603acf7d444f5f5df9d9008670e49b2ae0686c2e75c570eedc33b94b25cd2-d1bb78eded614735d3324103072f695d.png";